<template>
  <!-- 押金管理 -->
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <div v-if="add_type == 1">
        <el-button style="margin-left: 1px" @click="modals"
          >预收款存取</el-button
        >
        <el-button @click="searchs">搜索</el-button>
        <el-button @click="e_invoice">电子发票</el-button>
        <el-descriptions
          :column="2"
          border
          size="mini"
          style="margin-top: 10px"
          :labelStyle="{ width: '100px' }"
          :contentStyle="{ width: '43%' }"
        >
          <el-descriptions-item label="房产">
            <el-select
              v-model="select.text"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="可搜索房产"
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 100%"
            >
              <el-option
                v-for="item in selectList"
                :key="item.id"
                :label="item.house"
                :value="item.house"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="客户名称">
            <el-input
              size="mini"
              v-model="select.name"
              clearable
              placeholder="客户名称"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="收费项目">
            <el-select
              v-model="select.chargeitem_id"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="收费项目"
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 100%"
            >
              <el-option
                v-for="item in deposit_type"
                :key="item.id"
                :label="item.chargeItem_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="是否存在余额">
            <Space direction="vertical" size="large">
              <RadioGroup v-model="select.money">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </Space>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div v-else>
        <el-button style="margin-left: 1px" @click="add">保存</el-button>
        <el-button @click="tup">返回</el-button>
        <el-descriptions
          :column="2"
          border
          size="mini"
          style="margin-top: 10px"
          :labelStyle="{ width: '100px' }"
          :contentStyle="{ width: '43%' }"
        >
          <el-descriptions-item label="房产*" :labelStyle="{ color: 'red' }">
            <el-input
              class="cdj_input"
              v-model="form.house"
              placeholder="点击左边树选择房产"
              :disabled="true"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item
            label="选择客户*"
            :labelStyle="{ color: 'red' }"
          >
            <div style="display: flex">
              <el-input
                style="width: 80%"
                v-model="form.name"
                placeholder="客户姓名"
                :disabled="true"
              ></el-input>
              <el-button @click="user('')">选择客户</el-button>
            </div>
          </el-descriptions-item>
          <el-descriptions-item
            label="费用类型*"
            :labelStyle="{ color: 'red' }"
          >
            <el-select
              style="width: 100%"
              v-model="form.chargeitem_name_id"
              filterable
              placeholder="收费项目"
              class="kuan"
            >
              <el-option
                v-for="item in deposit_type"
                :key="item.id"
                :label="item.chargeItem_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item
            label="发生额(元)*"
            :labelStyle="{ color: 'red' }"
          >
            <el-input v-model="form.money" placeholder="金额"></el-input>
          </el-descriptions-item>
          <el-descriptions-item
            label="业务标记*"
            :labelStyle="{ color: 'red' }"
          >
            <el-select
              style="width: 100%"
              v-model="form.mark"
              filterable
              placeholder="业务标记"
              class="kuan"
            >
              <el-option
                v-for="item in mark"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item
            label="结算方式*"
            :labelStyle="{ color: 'red' }"
          >
            <el-select
              style="width: 100%"
              v-model="form.payment_name"
              filterable
              placeholder="结算方式"
              class="kuan"
            >
              <el-option
                v-for="item in payment"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="票据类型" :labelStyle="{ color: 'red' }">
            <el-select
              style="width: 100%"
              v-model="form.bill_type"
              @change="selects"
              filterable
              placeholder="票据类型"
              class="kuan"
            >
              <el-option
                v-for="item in bill_type"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="票据号码" :labelStyle="{ color: 'red' }">
            <el-input
              class="cdj_input"
              v-model="form.bill_number"
              placeholder="票据号码"
            ></el-input>
          </el-descriptions-item>
          <el-descriptions-item v-if="form.mark == 1" label="收取日期">
            <el-date-picker
              style="width: 100%"
              v-model="date"
              type="date"
              placeholder="日期"
              :disabled="ERP.isPermission(4003007011) == true ? false : true"
            ></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item v-if="form.mark == 2" label="退还日期">
            <el-date-picker
              style="width: 100%"
              v-model="date"
              type="date"
              placeholder="日期"
              :disabled="ERP.isPermission(4003007011) == true ? false : true"
            ></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="计费周期">
            <el-date-picker
              v-model="form.startDate"
              type="date"
              style="width: 47%"
              placeholder="开始日期"
            ></el-date-picker>
            <span style="margin-left: 1px; margin-right: 1px">至</span>
            <el-date-picker
              v-model="form.endDate"
              type="date"
              style="width: 47%"
              placeholder="结束日期"
            ></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input
              class="cdj_input"
              v-model="form.remarks"
              placeholder="请输入"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div style="margin-top: 10px; color: red">
        总金额：{{ money }}元
        <span style="margin-left: 20px" v-if="loading">加载中...</span>
      </div>
      <el-table
        ref="multipleTable"
        :height="height"
        :data="data"
        border
        style="width: 100%"
      >
        <el-table-column label="操作" width="200">
          <template slot-scope="data">
            <el-button
              style="color: #1e73e9"
              type="text"
              @click="detailed(data.row)"
              >查看明细</el-button
            >
            <el-button
              style="color: #1e73e9"
              type="text"
              @click="edit(data.row)"
              >预收款存取</el-button
            >
            <el-button
              style="color: #1e73e9"
              type="text"
              @click="user(data.row)"
              >过户</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="name" label="客户姓名" width="130" />
        <el-table-column prop="house" label="房产" />
        <el-table-column prop="chargeitem_name" label="收费项目" width="130" />
        <el-table-column prop="money" label="金额" width="80" />
        <el-table-column prop="balance" label="当期余额" width="80" />
        <el-table-column label="结算方式" width="150">
          <template slot-scope="data">
            {{ data.row.payment_name }}
            <el-button
              style="color: #1e73e9"
              size="mini"
              @click="editPaymentName(data.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" />
        <el-table-column label="收费项目修改" width="112">
          <template slot-scope="data">
            <el-button
              style="color: #1e73e9"
              type="text"
              @click="xiugai(data.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <v-divider></v-divider>
      <div class="pages" v-if="data">
        <el-pagination @size-change="changeSize"
                       @current-change="handleCurrentChange"
                       :current-page="select.page"
                       :page-sizes="[20,100,200,500,1000]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="count">
        </el-pagination>
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
    <!-- 修改收费项/计费周期 -->
    <Modal
      v-model="modal3"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      :mask-closable="maskclosable"
      :mask="maskclosable"
      title="修改收费项目"
      @on-ok="adds"
    >
      <div>
        <el-form style="height: 600px; overflow: auto">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>费用类型</span>
            <div class="cdj_input">
              <el-select
                style="width: 100%"
                v-model="form.chargeitem_name_id"
                filterable
                placeholder="押金类型"
                class="kuan"
              >
                <el-option
                  v-for="item in deposit_type"
                  :key="item.id"
                  :label="item.chargeItem_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="cdj_margin_span">
            <span>计费周期</span>
            <div class="cdj_input">
              <el-date-picker
                v-model="datevalue"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div> -->
          <!-- <div class="cdj_margin_span">
             <span>备注</span>
             <el-input class="cdj_input" v-model="form.remarks" placeholder="请输入"></el-input>
           </div> -->
        </el-form>
      </div>
    </Modal>

    <Modal
      v-model="modal4"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      :mask-closable="maskclosable"
      :mask="maskclosable"
      title="修改结算方式"
      @on-ok="alterPaymentName"
    >
      <div>
        <el-form style="height: 600px; overflow: auto">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>结算方式</span>
            <div class="cdj_input">
              <el-select
                style="width: 100%"
                v-model="form.payment_name"
                filterable
                placeholder="结算方式"
                class="kuan"
              >
                <el-option
                  v-for="item in payment"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 明细 -->
    <Modal
      v-model="modal2"
      ok-text="关闭"
      width="80%"
      title="明细"
      :loading="loadingModal"
      @on-ok="oks"
    >
      <div>
        <el-form style="height: 600px; overflow: auto">
          <div>
            <template>
              <el-table :data="detaileds" border style="width: 100%">
                <el-table-column prop="date" label="操作" width="150">
                  <template slot-scope="scope">
                    <div style="display: flex">
                      <div
                        v-if="scope.row.mark == '预收款收入'"
                        style="color: #1e73e9; cursor: pointer"
                        @click="billPrintClick(scope.row)"
                      >
                        打印票据
                      </div>
                      <div
                        v-if="
                          scope.row.order_detail_id != '' &&
                          scope.row.order_detail_id != null &&
                          ERP.isPermission(4003010003)
                        "
                        style="
                          color: #1e73e9;
                          cursor: pointer;
                          margin-left: 7px;
                        "
                        @click="drawback(scope.row)"
                      >
                        冲销
                      </div>
                      <div
                        v-if="
                          scope.row.mark == '预收款收入' &&
                          ERP.isPermission(4003010004)
                        "
                        style="
                          color: #1e73e9;
                          cursor: pointer;
                          margin-left: 7px;
                        "
                        @click="IsCanceled(scope.row)"
                      >
                        作废
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="id"
                  label="ID"
                  width="90"
                ></el-table-column>
                <el-table-column
                  prop="money"
                  label="金额"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="bill_type"
                  label="票据类型"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="bill_number"
                  label="票据号码"
                  width="130"
                ></el-table-column>
                <el-table-column
                  prop="payment_name"
                  label="结算方式"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="charge_date"
                  label="收取时间"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="mark"
                  label="业务标记"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="state"
                  label="状态"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="remarks"
                  label="备注"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="date"
                  label="添加时间"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="操作人"
                  width="100"
                ></el-table-column>
              </el-table>
            </template>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 打印display: none; -->
    <div
      style="
        position: absolute;
        bottom: 100px;
        left: 500px;
        width: 700px;
        display: none;
      "
    >
      <div id="printBill">
        <div style="font-size: 14px; color: #000000; font-family: 楷体">
          <div
            style="
              width: 100%;
              text-align: center;
              margin-top: 30px;
              font-size: 20px;
            "
          >
            {{ deposit.company }} 收款收据
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 75%">房号：{{ deposit.house }}</div>
            <div style="width: 25%; margin-left: 50px">
              付款方式：{{ deposit.payment_name }}
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 40%">客户：{{ deposit.name }}</div>
            <div style="width: 33%; margin-left: 5px">
              收据单号：{{ deposit.bill_number }}
            </div>
            <div style="width: 34%; text-align: right; margin-right: 25px">
              开票日期：{{ deposit.advance_date }}
            </div>
          </div>
          <div style="margin-top: 1px; line-height: 17px">
            <table
              align="center"
              style="width: 100%; border-collapse: collapse"
            >
              <tr>
                <th
                  style="border: 1px solid #000000; width: 150px"
                  align="center"
                  valign="middle"
                >
                  收费项目
                </th>
                <th
                  style="border: 1px solid #000000; width: 200px"
                  align="center"
                  valign="middle"
                >
                  收取日期
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  class="ddd"
                  align="center"
                  valign="middle"
                >
                  面积
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  数量
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  预收款
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  金额
                </th>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.chargeitem_name }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.charge_date }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                ></td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  1
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.money }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.money }}
                </td>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  合计（大写）：
                </td>
                <td
                  style="border: 1px solid #000000; text-align: left"
                  colspan="3"
                  align="center"
                  valign="middle"
                >
                  <span style="margin-left: 5px">{{ capitalize }}</span>
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  （小写）：
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.money }}
                </td>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  备注：
                </td>
                <td
                  style="border: 1px solid #000000; text-align: left"
                  colspan="5"
                  align="center"
                  valign="middle"
                >
                  <span style="margin-left: 5px">{{ deposit.remarks }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 70%; margin-top: 20px">
            说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%">开票人：{{ login }}</div>
            <div style="width: 33%">收款人：{{ deposit.login_name }}</div>
            <div style="width: 34%; text-align: right; margin-right: 94px">
              收款单位（盖章）
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%"></div>
            <div style="width: 33%"></div>
            <div style="width: 34%; text-align: right; margin-right: 70px">
              打印时间：{{ deposit.advance_date }}
            </div>
          </div>
          <div style="text-align: center; margin-top: 7px">
            打印次数<span style="margin-left: 30px">{{
              deposit.frequency
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗选择用户 -->
    <Modal v-model="modal1" width="800" title="选择客户" @on-ok="roomUser">
      <div>
        <room-user
          style="height: 600px"
          ref="child"
          :house="house_1"
        ></room-user>
      </div>
    </Modal>
    <advance-invoice
      :dialog-visible.sync="invoiceVisable"
      :house-name="select.text"
      :pindex-id="project_id"
      @close="closeEInvoice"
    />

  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
import print from "print-js";
import advanceInvoice from "./advanceInvoice.vue";

export default {
  name: "OrderAdvance",
  data() {
    return {
      user_update: "",
      money: 0,
      height: "50vh",
      add_type: 1,
      select: {
        text: "",
        name: "",
        chargeitem_id: "",
        money: "",
      },
      house_1: "",
      selectList: [],
      project_id: "",
      datevalue: [],
      maskclosable: false,
      modal1: false,
      modal: false,
      modal2: false,
      modal3: false,
      modal4: false,
      statesModal: false,
      loading: false,
      loadingModal: true,
      unlinkpanels: true,
      options: [],
      payment: [],
      charge: [],
      house: [],
      count: 0,
      pageSize: 12,
      data: [],
      pid: "",
      text: "",
      state: "1",
      url: "",
      fileList: [],
      form: {
        customer_id: "",
        startDate: "",
        endDate: "",
        pindex_id: "",
        house_id: "",
        name: "",
        house: "",
        payment_name: "",
        chargeitem_name_id: "",
        money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        remarks: "",
        mark: 1,
        startDate: "",
        endDate: "",
      },
      statesForm: {
        id: "",
        payment_name: "",
        retreat_money: "",
        retreat_date: "",
        remarks: "",
      },
      deposit_type: [],
      date: "",
      bill_type: [
        {
          id: 1,
          name: "收据",
        },
        {
          id: 2,
          name: "中奥收据",
        },
        {
          id: 3,
          name: "电子发票",
        },
        {
          id: 4,
          name: "资金往来发票",
        },
        {
          id: 5,
          name: "定额发票20元",
        },
        {
          id: 6,
          name: "增值税专用发票",
        },
        {
          id: 7,
          name: "服务业通用发票",
        },
        {
          id: 8,
          name: "停车场专用发票",
        },
        {
          id: 9,
          name: "红字发票",
        },
        {
          id: 10,
          name: "增值税普通发票",
        },
        {
          id: 11,
          name: "定额发票5元",
        },
        {
          id: 12,
          name: "系统导入票据",
        },
        {
          id: 13,
          name: "定额发票1元",
        },
        {
          id: 14,
          name: "中奥-收据",
        },
      ],
      mark: [
        { id: 1, name: "预收款收入" },
        { id: 2, name: "预收款退款" },
      ],
      detaileds: [],
      deposit: [],
      capitalize: "",
      login: "",
      money: 0,
      advance_id: "",
      detailed_id: "",
      invoiceVisable: false,
    };
  },
  components: {
    "erp-tree": () => import("../Common/erp-tree.vue"),
    "room-user": () => import("../Common/room-user.vue"),
    advanceInvoice,
  },
  created() {},
  mounted() {
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token;
    //项目列表
    this.$myhttp
      .get("admin/common/pindex", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.options = backdata.data.data;
      });
    //加载收款方式
    this.$myhttp
      .get("admin/common/payment", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.payment = backdata.data.data;
      });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  methods: {
    //作废
    IsCanceled(data) {
      this.$confirm("确定作废吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ERP.showLoading();
        this.$myhttp
          .post("admin/Advance/IsCanceled", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then(
            (backdata) => {
              // 异步执行成功后
              ERP.hideLoading();
              if (backdata.data.code == 200) {
                this.$Message.success(backdata.data.message);
                this.searchs();
                this.detailed(this.detailed_id);
              } else {
                this.$Message.error(backdata.data.message);
              }
            },
            (err) => {
              ERP.hideLoading();
              this.$Message.error("超时");
            }
          );
      });
    },
    tup() {
      this.add_type = 1;
      this.height = "50vh";
    },
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    selects(e) {
      if (this.form.bill_type == "" || this.form.bill_type == null) {
        this.form.bill_number = "";
        return false;
      }
      if (this.form.pindex_id == "" || this.form.pindex_id == null) {
        return false;
      }
      if (e == "收据" || e == "中奥收据" || e == "中奥-收据") {
        let pindex_id = this.form.pindex_id;
        this.$myhttp
          .get("admin/common/getBills?pindex_id=" + pindex_id, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            let data = backdata.data.data;
            this.form.bill_number = data.top + data.number + data.bill;
          });
      } else {
        this.form.bill_number = "";
      }
    },
    //打印
    billPrintClick(item) {
      //console.log(item);
      this.login = window.localStorage.getItem("login");
      this.$myhttp
        .post("admin/Advance/advance", item, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.deposit = backdata.data.data;
          let money = this.deposit.money;
          this.capitalize = this.transCnMoney(money);
          this.day();
        });
    },
    //打印
    day() {
      let _this = this;
      setTimeout(function () {
        const style = "@page {margin:0 10mm};"; //打印时去掉眉页眉尾
        printJS({
          printable: "printBill", // 标签元素id
          type: "html",
          header: "",
          targetStyles: ["*"],
          scanStyles: false, //打印必须加上，不然页面上的css样式无效
          style,
        });
      }, 100);
    },
    //数字转大写
    transCnMoney(number) {
      var CN_MONEY = "";
      var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
      number = parseFloat(number).toFixed(2).toString(); //浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
      var dot = number.indexOf("."); //将从小数点开始分开
      if (dot >= 0) {
        number = number.substring(0, dot) + number.substr(dot + 1, 2);
        CN_UNIT = CN_UNIT.substr(CN_UNIT.length - number.length);
        for (var i = 0; i < number.length; i++) {
          CN_MONEY +=
            "零壹贰叁肆伍陆柒捌玖".substr(number.substr(i, 1), 1) +
            CN_UNIT.substr(i, 1);
        }
        return CN_MONEY.replace(/零角零分$/, "整")
          .replace(/零[仟佰拾]/g, "零")
          .replace(/零{2,}/g, "零")
          .replace(/零([亿|万])/g, "$1")
          .replace(/零+元/, "元")
          .replace(/亿零{0,3}万/, "亿")
          .replace(/^元/, "零元");
      } else {
      }
    },

    //树搜索
    nodeClick(data) {
      //console.log(data);
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.select.text = tree_str;
      this.form.house = tree_str;
      this.change(1);
      let tree = data.tree;
      // console.log(tree)
      this.form.pindex_id = tree[0].id;
      let _this = this;
      this.form.bill_type = "";
      this.form.bill_number = "";
      this.form.money = "";
      this.money = 0;
      tree.forEach(function (it) {
        if (it.type == "room") {
          _this.form.name = it.customerName;
          _this.form.house_id = it.id;
          _this.tableDatas(tree[0].id, tree_str);
        }
      });
      //收费项
      this.$myhttp
        .get("admin/common/p_chargeitem_name?pid=" + this.project_id, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.deposit_type = backdata.data.data;
        });
    },
    modals() {
      this.add_type = 2;
      this.height = 400;
      this.select.money = "是";
      // this.modal = true;
    },
    //编辑
    edit(it) {
      this.add_type = 2;
      this.height = 400;
      this.select.money = "是";
      this.form = {
        pindex_id: it.pindex_id,
        house_id: it.house_id,
        name: it.name,
        house: it.house,
        payment_name: "",
        chargeitem_name_id: it.chargeitem_name_id,
        money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        remarks: "",
        mark: 1,
        startDate: it.startDate,
        endDate: it.endDate,
        customer_id: it.customer_id,
      };
      this.money = it.money;
      this.datevalue = [];
      if (it.startDate) {
        this.datevalue = [it.startDate, it.endDate];
      }
      this.state = it.house;
      this.project_id = it.pindex_id;
      this.select.text = it.house;
      this.change(1);
      // this.date = '';
      this.modal = true;
    },
    //保存
    add() {
      if (this.form.mark == 1) {
        if (this.form.name == "") {
          this.$Message.error("客户姓名不能为空!");
          this.loadingModals();
          return false;
        }
      }
      if (this.form.house == "") {
        this.$Message.error("点击左边树选择房产");
        this.loadingModals();
        return false;
      }
      if (this.form.payment_name == "") {
        this.$Message.error("结算方式不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.mark == "") {
        this.$Message.error("业务标记不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.chargeitem_name_id == "") {
        this.$Message.error("费用类型不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.money == "") {
        this.$Message.error("金额不能为空!");
        this.loadingModals();
        return false;
      }
      if (
        this.date != null &&
        this.date != NaN &&
        this.date != "" &&
        this.date != null
      ) {
        var d = this.date;
        this.form.charge_date = new Date(d).getTime() / 1000;
      } else {
        this.$Message.error("请选择收取日期");
        this.loadingModals();
        return false;
      }
      if (this.form.bill_type == "") {
        this.$Message.error("票据类型不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.bill_number == "") {
        this.$Message.error("票据号码不能为空!");
        this.loadingModals();
        return false;
      }
      ERP.showLoading();
      this.$myhttp
        .post("admin/Advance/add", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          ERP.hideLoading();
          // 异步执行成功后
          this.modal = false;
          if (backdata.data.code == 201) {
            this.$Message.error(backdata.data.message);
            return false;
          }
          if (backdata.data.code == 200 || backdata.data.code == 202) {
            this.form.money = "";
            this.form.bill_type = "";
            this.form.bill_number = "";
            this.modal = false;
            this.change(1);
            this.$Message.success("提交成功!");
          }
          if (backdata.data.code == 202) {
            this.$confirm("是否需要打印票据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.billPrintClick(backdata.data.data);
              })
              .catch(() => {});
          }
        });
    },

    //查看明细
    detailed(item) {
      this.detailed_id = item;
      this.modal2 = true;
      this.$myhttp
        .get("admin/Advance/detailed?id=" + item.id, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.detaileds = backdata.data.data;
        });
    },
    oks() {
      this.modal2 = false;
    },
    //分页
    change(page) {
      console.log('4003010002',ERP.isPermission(4003010002));
      this.loading = true;
      this.money = 0;
      this.select.page = page;
      this.select.pageSize = this.pageSize;
      this.select.state = this.state;
      this.select.pid = this.project_id;
      this.$myhttp
        .post("admin/Advance/index", this.select, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then(
          (backdata) => {
            // 异步执行成功后
            this.loading = false;
            if (backdata.data.code == 201) {
              this.$Message.error(backdata.data.message);
            } else {
              let data = backdata.data;
              this.data = data.data.data;
              this.count = data.data.count;
              // this.pageSize = data.data.pageSize;
              this.date = data.data.date;
              this.money = data.data.money;
            }
          },
          (err) => {
            this.loading = false;
            this.$Message.error("请求异常!");
          }
        );
    },
    handleCurrentChange(e){
      // this.page = e;//第几页
      this.change(e);
    },
    changeSize(e){
      this.pageSize = e;
      this.change(1);
    },
    //修改收费项/计费周期
    xiugai(it) {
      this.advance_id = it.id;
      this.form = {
        pindex_id: it.pindex_id,
        house_id: it.house_id,
        name: it.name,
        house: it.house,
        payment_name: "",
        chargeitem_name_id: it.chargeitem_name_id,
        money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        remarks: "",
        mark: 1,
        startDate: it.startDate,
        endDate: it.endDate,
      };
      this.datevalue = [];
      if (it.startDate) {
        this.datevalue = [it.startDate, it.endDate];
      }
      this.modal3 = true;
      // var text;
      // var types;
      // if(it.type == "否"){
      //   types = 2;
      //   text = '共享'
      // }else{
      //   types = 1;
      //   text = '不共享'
      // }
      // this.$confirm('确定改为'+text+', 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(() => {
      //   this.loading=true;
      //   this.$myhttp.post('admin/Advance/type',{id:it.id,type:types},{
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //     }).then(backdata=>{ // 异步执行成功后
      //       this.loading=false;
      //       this.$Message.success('操作成功!');
      //       this.change(1);
      //   });
      // }).catch(() => {

      // });
    },
    //修改收费项/计费周期
    adds() {
      if (this.form.chargeitem_name_id == "") {
        this.$Message.error("费用类型不能为空!");
        this.loadingModals();
        return false;
      }
      let dates = this.datevalue;
      if (this.datevalue != null) {
        var d = this.datevalue[0]; //开始时间
        var e = this.datevalue[1]; //结束时间
        this.form.startDate = new Date(d).getTime() / 1000;
        this.form.endDate = new Date(e).getTime() / 1000;
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.form.advance_id = this.advance_id;
      // this.loadingModals();
      // console.log(this.form)
      this.loading = true;
      this.$myhttp
        .post("admin/Advance/type", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.loadingModals();
          this.loading = false;
          this.$Message.success("操作成功!");
          this.change(1);
          this.modal3 = false;
        });
    },
    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
    },
    //弹窗不要关闭
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    editPaymentName(it) {
      this.advance_id = it.id;
      this.form = {
        pindex_id: it.pindex_id,
        house_id: it.house_id,
        name: it.name,
        house: it.house,
        payment_name: it.payment_name,
        chargeitem_name_id: it.chargeitem_name_id,
        money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        remarks: "",
        mark: 1,
        startDate: it.startDate,
        endDate: it.endDate,
        customer_id: it.customer_id,
      };
      this.datevalue = [];
      if (it.startDate) {
        this.datevalue = [it.startDate, it.endDate];
      }
      this.modal4 = true;
    },
    alterPaymentName() {
      if (this.form.payment_name == "") {
        this.$Message.error("结算类型不能为空!");
        this.loadingModals();
        return false;
      }
      this.form.advance_id = this.advance_id;
      this.loading = true;
      this.$myhttp
        .post("admin/Advances/editPaymentName", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            // 异步执行成功后
            this.loadingModals();
            this.loading = false;
            this.$Message.success("操作成功!");
            this.change(1);
            this.modal4 = false;
          } else {
            this.loadingModals();
            this.loading = false;
            this.$Message.error(backdata.data.msg);
            this.modal4 = false;
          }
        });
    },
    //预收款冲销
    drawback(data) {
      this.$confirm("确定冲销吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ERP.showLoading();
        this.$myhttp
          .post("admin/Advance/drawback", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then(
            (backdata) => {
              // 异步执行成功后
              ERP.hideLoading();
              if (backdata.data.code == 200) {
                this.$Message.success(backdata.data.message);
                this.detailed(this.detailed_id);
              } else {
                this.$Message.error(backdata.data.message);
              }
            },
            (err) => {
              ERP.hideLoading();
              this.$Message.error("超时");
            }
          );
      });
    },
    //选择客户
    user(data) {
      this.user_update = data;
      this.house_1 = this.select.text;
      this.modal1 = true;
    },
    roomUser() {
      let user = this.$refs.child.getUser();
      //console.log(user);
      if (user.id) {
        this.form.customer_id = user.id;
        this.form.name = user.name;

        //修改
        let data = { user_update: this.user_update, form: this.form };
        this.$myhttp
          .post("admin/Advance/update_user", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then(
            (backdata) => {
              // 异步执行成功后
              if (backdata.data.code == 200) {
                this.$Message.success(backdata.data.message);
                this.change(1);
              } else {
              }
            },
            (err) => {
              this.$Message.error("超时");
            }
          );
      }
    },
    tableDatas(pid, tree_str) {
      this.$myhttp
        .get("admin/Temporary/house?house=" + tree_str, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          //console.log(backdata.data);
          if (backdata.data.customer != "") {
            this.form.customer_id = backdata.data.customer[0].id;
            this.form.name = backdata.data.customer[0].name;
          } else {
            this.form.name = "";
          }
        });
    },
    e_invoice() {
      if (this.project_id == "") {
        this.$message.error("请选择项目");
        return;
      }
      this.invoiceVisable = true;
    },
    closeEInvoice() {
      this.invoiceVisable = false;
    },
  },
  watch: {},
};
</script>

<style>
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #3e3f42 !important;
  cursor: not-allowed;
}
.my-label {
  color: red;
}
</style>

<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/advance.vue